<template>
  <div class="page messainmorapec">

    <Toast :group="page.name" position="bottom-center" />
    <Loader v-if="loader" />

    <accordion :multiple="true" :activeIndex="[0, 1]" >
      <accordion-tab>
        <template #header>
          <span>Fatture Scadute</span>
        </template>

        <div v-if="data_.fattureScadute.length > 0">
          <div v-for="(item, index) in data_.fattureScadute" :key="index">
            <div v-if="item">
              
              <div class="client">
                <span class="name">{{ item.cliente }} &nbsp;- </span>&nbsp;
                <span class="price">{{ currencyFormatter.format( (item.totale !== null)? item.totale: 0 ) }}</span>
              </div>
              

              <data-table :value="item.fatture" v-model:selection="data_.selectedInvoices[index]" dataKey="numero" responsiveLayout="scroll" >
                <template #empty>
                    <div class="text-center">Nessun dato trovato.</div>
                </template>
                <column selectionMode="multiple" headerStyle="width: 3em"></column>
                <column field="numero" header="Numero"></column>
                <column field="contatto" header="Contatto"> </column>
                <column field="data_emissione" header="Data Emissione">
                  <template #body="{data}">
                    {{ (data.data_emissione !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="data_scadenza" header="Data Scadenza">
                  <template #body="{data}">
                    {{ (data.data_scadenza !== null)? moment(data.data_scadenza).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="saldo" header="Importo Dovuto">
                  <template #body="{data}">
                    {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
                  </template>
                </column>
              </data-table>

              <div v-if="data_.selectedInvoices[index].length > 0" class="p-d-flex p-p-3 card">
                <prime-button label="Aggiungi" icon="pi pi-plus-circle" class="mb-auto" @click="onAddFatturaToMessaInMoraButton(index)" />
              </div>

            </div>
          </div>
        </div>
      </accordion-tab>
      
      <accordion-tab>
        <template #header>
          <span>Messa in mora</span>
        </template>

        <div v-if="data_.fattureInMessaInMora.length > 0">
          <div v-for="(item, index) in data_.fattureInMessaInMora" :key="index">
            <div v-if="item">

              <div class="client">
                <span class="name">{{ item.cliente }} &nbsp;- </span>&nbsp;
                <span class="price">{{ currencyFormatter.format( (item.totale !== null)? item.totale: 0 ) }}</span>
              </div>
              

              <data-table :value="item.fatture" v-model:selection="data_.selectedInMessaInMora[index]" dataKey="numero" responsiveLayout="scroll" >
                <template #empty>
                    <div class="text-center">Nessun dato trovato.</div>
                </template>
                <column selectionMode="multiple" headerStyle="width: 3em"></column>
                <column field="numero" header="Numero"></column>
                <column field="contatto" header="Contatto"></column>
                <column field="data_emissione" header="Data Emissione">
                  <template #body="{data}">
                    {{ (data.data_emissione !== null)? moment(data.data_emissione).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="data_scadenza" header="Data Scadenza">
                  <template #body="{data}">
                    {{ (data.data_scadenza !== null)? moment(data.data_scadenza).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="saldo" header="Importo Dovuto">
                  <template #body="{data}">
                    {{currencyFormatter.format( (data.saldo !== null)? data.saldo: 0 )}}
                  </template>
                </column>
                <column field="data_messa_in_mora" header="Data Messa In Mora">
                  <template #body="{data}">
                    {{ (data.data_messa_in_mora !== null)? moment(data.data_messa_in_mora).format('DD/MM/YYYY'): '' }}
                  </template>
                </column>
                <column field="data_invio_messa_in_mora" header="Data Invio">
                  <template #body="{data, field}">
                    {{ (data[field] !== null)? moment(data[field] ).format('DD/MM/YYYY HH:mm'): '' }}
                  </template>
                </column>
              </data-table>

              <div class="p-d-flex p-p-3 card">
                <prime-button iconPos="right" label="Invia a contatto" icon="pi pi-envelope" class="mb-auto" @click="sendToContacts(index)" />
                <prime-button iconPos="right" label="Scarica" icon="pi pi-download" class="ml-2" @click="onGetPdfButton(index)" />
              </div>

            </div>
          </div>
        </div>

      </accordion-tab>

    </accordion>

  </div>
</template>

<script>
import moment from 'moment'
import slugify from 'slugify'

import Service from '@/services/ask-management/messa-in-mora-fatture-clienti-service'

import PrimeButton from 'primevue/button'
import Loader from '@/components/Loader.vue'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton,
    Loader
  },

  data() {
    return {
      moment,
      loader: false,
      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      page:{
        name: 'clienti-messa-in-mora-pec',
      },

      data_:{
        selectedInvoices: [],
        selectedInMessaInMora: [],

        clientiIds: this.data,
        fattureScadute: [],
        fattureInMessaInMora: [],
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getAllFattureScadute()
    this.getAllFattureInMessaInMora()
  },

  methods:{

    onCancelButton(){
      this._reset()
      
      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    /////

    onAddFatturaToMessaInMoraButton(index){
      this.service.insertFattureToMessaInMora({
        'fattura_vendita.numeri': this.data_.selectedInvoices[index].map((el) => el.numero)
      }).then((res) => {
        this.data_.selectedInvoices[index] = []

        if(res.result){
          this.getAllFattureScadute()
          this.getAllFattureInMessaInMora()
        }
      })
    },


    sendToContacts(index){
      
      this.$toast.removeGroup(this.page.name);
      if (this.data_.selectedInMessaInMora.length > 0 && this.data_.selectedInMessaInMora[index].length > 0) {
        let contatto = this.data_.selectedInMessaInMora[index][0].contatto
        
        if (contatto != null && contatto != '') {
          this.loader = true
          this.service.sendMessaInMoraToPec({
            'fattura_vendita.numeri': this.data_.selectedInMessaInMora[index].map((el) => el.numero)
          }).then((res) =>{
            if (res.item.success) {
              this.$toast.add({severity:'success', summary: 'Successo', detail:'Inviata', group: this.page.name});
            } else {
              this.$toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell\'invio', group: this.page.name});
            }
          }).finally(()=>{
            this.loader = false
          })
        } else {
          this.$toast.add({severity:'warn', summary: 'Attenzione', detail:'Il cliente non ha nessun contatto', group: this.page.name});
        }
        
      } else {
         this.$toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun elemento selezionato', group: this.page.name});
      }
      
    },

    onGetPdfButton(index){
      
      if (this.data_.selectedInMessaInMora.length > 0 && this.data_.selectedInMessaInMora[index].length > 0) {
        this.loader = true
        this.service.downloadFileMessaInMoraZip({
          'fattura_vendita.numeri': this.data_.selectedInMessaInMora[index].map((el) => el.numero)
        }).finally(()=>{
          this.loader = false
        })
      }
      else {
        console.log('else');
        this.$toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun elemento selezionato', group:this.page.name});
      }
    },

    ////

    _reset(){
      this.data_.selectedInvoices = []
      this.data_.selectedInMessaInMora = []

      this.data_.clientiIds = []
      this.data_.fattureScadute = []
      this.data_.fattureInMessaInMora = []
    },

    getAllFattureScadute(){
      this.loader = true
      this.service.getAllFattureScadute({
        'cliente.ids': this.data_.clientiIds
      }).then((res) => {
        this.data_.fattureScadute = Object.entries(res.item).map((el) => {
          return {
            slug: slugify(el[0], {lower: true}),
            cliente: el[0],
            totale: el[1].totale,
            fatture: el[1].fatture
          }
        })

        this.data_.fattureScadute.forEach((_, i) => {
          this.data_.selectedInvoices[i] = []
        })
      }).finally(()=>{
        this.loader = false
      })
    },

    getAllFattureInMessaInMora(){
      this.loader = true
      this.service.getAllFattureInMessaInMora({
        'cliente.ids': this.data_.clientiIds
      }).then((res) => {
        this.data_.fattureInMessaInMora = Object.entries(res.item).map((el) => {
          return {
            slug: slugify(el[0], {lower: true}),
            cliente: el[0],
            totale: el[1].totale,
            fatture: el[1].fatture
          }
        })
      }).finally(()=>{
        this.loader = false
      })
    },
  },

}
</script>

<style>
.messainmorapec .p-accordion-tab:nth-child(1) .p-accordion-header-link{
 
}
.messainmorapec .client{
  margin: 10px 1px;
  display: inline-block;
  background-color: var(--blue-100);
  padding: 6px 12px;
  border-radius: 5px;
}
.messainmorapec .client .name {
  color: #818181;
}
.messainmorapec .client .price {
  color: #fd4e4e;
}
.messainmorapec .p-accordion-tab:nth-child(2) .p-accordion-header-link{
  margin-top: 40px !important;
  border: 1px solid#dee2e6 !important;
}
</style>
